import { HTTPError as KyHttpError, TimeoutError as KyTimeoutError } from 'ky';

import { HttpError } from './HttpError';
import { NetworkError } from './NetworkError';
import { TimeoutError } from './TimeoutError';

import isNetworkError from 'is-network-error';

export const parseError = async (error: unknown) => {
    if (error instanceof KyHttpError) {
        return await HttpError.fromKyError(error);
    }

    if (error instanceof KyTimeoutError) {
        return new TimeoutError(error.request);
    }

    if (isNetworkError(error)) {
        return new NetworkError(error.message);
    }

    if (error instanceof Error) {
        return error;
    }

    return new Error(`Unknown error: ${Object.prototype.toString.call(error)}`);
};
